import {AdminRole, ProRole} from './auth-status.service'

export abstract class AuthService {
  abstract signIn(email: string): Promise<void>
  abstract completeSignInChallenge(email: string, answer: string): Promise<void>
  abstract signOut(): Promise<void>

  parseRole<T = ProRole | AdminRole>(brn?: string): T | undefined {
    if (brn) {
      return AuthService.parseBrn<T>(brn).role
    } else {
      return undefined
    }
  }

  static parseBrn<T = ProRole>(brn: string): {namespace: 'pro'; entityId: string; role: T}
  static parseBrn<T = AdminRole>(brn: string): {namespace: 'admin'; entityId: string; role: T}
  static parseBrn(brn: string): {namespace: string; entityId: string; role: string} {
    const split = brn.split(':')
    if (split.length !== 4) {
      throw new Error(`Invalid BRN: Could not parse '${brn}'`)
    }
    if (split[0] !== 'brn') {
      throw new Error(`Invalid BRN: Could not parse '${brn}'`)
    }
    return {
      namespace: split[1],
      entityId: split[2],
      role: split[3],
    }
  }
}

export type AuthenticationErrorCode =
  | 'USERNAME_ALREADY_EXIST'
  | 'USER_NOT_FOUND'
  | 'USER_DISABLED'
  | 'WRONG_DEVICE' // this happens when a user entered his email in a device, and opened the sign in link in another device
  | 'CHALLENGE_REJECTED' // challenge failed, sign in should restart

export class AuthenticationError extends Error {
  constructor(
    public readonly code: AuthenticationErrorCode,
    message: string,
  ) {
    super(message)
  }
}
